"use strict";
// @ts-ignore
try {
    self['workbox:navigation-preload:7.1.0'] && _();
}
catch (e) { }
